
import {
  GET_INVENTORY_REPORT_REQUEST,
  GET_INVENTORY_REPORT_SUCCESS,
  GET_INVENTORY_REPORT_ERROR
} from "../actions/types";

export const inventory = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_INVENTORY_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_INVENTORY_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_INVENTORY_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};